<template>
  <Paginate
    v-model="page"
    :page-count="pageNumber"
    :page-range="10"
    :init-page="0"
    :margin-pages="1"
    prev-text="<"
    next-text=">"
    container-class="pagination justify-content-center"
    page-class="page-item"
    page-link-class="page-link"
    prev-class="page-item"
    prev-link-class="page-link"
    next-class="page-item"
    next-link-class="page-link"
    break-view-class="page-item"
    break-view-link-class="page-link"
    :click-handler="pageChangeHandler"
  />
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  name: 'Pagination',
  components: {
    Paginate
  },
  props: {
    page: {
      type: Number,
      default: 0
    },
    pageNumber: {
      type: Number,
      default: 0
    },
    pageChangeHandler: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
